import React from 'react';
import { Link } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';

/**
 * When viewport is mobile (≤767px), renders a full-page message that the experience
 * requires a computer or iPad. Otherwise renders children.
 * @param {React.ReactNode} children - Content to show on desktop/tablet.
 * @param {string} [backTo] - Path for "Back" link (e.g. "/", "/seawolf-practice").
 * @param {string} [backLabel] - Label for the back link (e.g. "Back to home", "View Sea Wolf practice").
 */
export default function RequireDesktopOrIpad({ children, backTo = '/', backLabel = 'Back to home' }) {
  const isMobile = useIsMobile(767);

  if (!isMobile) {
    return children;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900 text-white p-6 text-center">
      <div className="max-w-md flex flex-col items-center gap-6">
        <div className="w-16 h-16 rounded-2xl bg-slate-700/80 flex items-center justify-center">
          <svg className="w-8 h-8 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-white">
          This experience works best on a computer or iPad
        </h1>
        <p className="text-slate-300 text-sm leading-relaxed">
          Please switch to a larger screen to continue. You can still explore our guides and pricing on your phone.
        </p>
        <Link
          to={backTo}
          className="inline-flex items-center justify-center px-5 py-3 text-sm font-semibold rounded-xl bg-white/10 text-white border border-white/20 hover:bg-white/15 transition-colors"
        >
          {backLabel}
        </Link>
      </div>
    </div>
  );
}
